import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { Typography } from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";
import { Box, FlexContainer, FlexDiv, Button } from "@/components/Atoms";
import { getCardsData } from "../constats";
import { StrikeThrough } from "../BannerSection";
import SVGRing from "@/components/Atoms/SVGSprite";

const CardComponent = (props) => {
  const { cardRef, programType } = props || {};
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 699,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: true,
        },
      },
    ],
  };
  return (
    <FlexDiv py={"40px"} flexDirection="column" ref={cardRef}>
      <FlexContainer flexDirection="column" alignItems={"center"}>
        <Heading
          textAlign={"center"}
          variant="heading2"
          color={theme.colors.link2Color}
        >
          {getCardsData(programType).card_title}
        </Heading>
        {getCardsData(programType).card_subtitle && (
          <Subtitle
            textAlign={"center"}
            variant="paragraph1"
            color={theme.colors.gray_90}
          >
            {getCardsData(programType).card_subtitle}
          </Subtitle>
        )}
        <FlexDiv width={"100%"} flexDirection="column">
          <SlideWrap mx={"-10px"}>
            <Slider {...settings}>
              {getCardsData(programType).CARDS.length > 0 &&
                getCardsData(programType)?.CARDS.map((item, index) => {
                  return (
                    <CardBody
                      flexDirection={"column"}
                      alignItems={"flex-start"}
                      key={index}
                      bgImg={item.cardColor}
                    >
                      <TopBox>
                        <Box>
                          <Typography
                            variant={"title1"}
                            color={theme.colors.white}
                          >
                            {item?.package_duration}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            variant={"title1"}
                            color={theme.colors.white}
                          >
                            {item?.currency_symbol}{" "}
                            {item?.old_price && (
                              <>
                                <StrikeThrough>{item?.old_price}</StrikeThrough>{" "}
                              </>
                            )}
                            {item?.price}
                          </Typography>
                        </Box>
                      </TopBox>
                      <BtnDiv width={"100%"}>
                        <Button
                          variant={"primary1"}
                          bgColor={theme.colors.white}
                          hoverColor={theme.colors.white}
                          TextColor={theme.colors.gray_100}
                          onClick={() => props?.openPaymentPage(item)}
                          fontSize={"16px"}
                          fontFamily={"var(--font-700)"}
                          btnPadding={"11px 46px"}
                        >
                          {item?.cta_btn}
                        </Button>
                      </BtnDiv>
                      {item.tag_text && (
                        <CardBanner>
                          <Typography
                            variant="paragraph3"
                            fontFamily={"var(--font-700)"}
                            color={theme.colors.back_26}
                          >
                            {item.tag_text}
                          </Typography>
                        </CardBanner>
                      )}
                      <SvgCard active={item?.cardColor} />
                    </CardBody>
                  );
                })}
            </Slider>
          </SlideWrap>
        </FlexDiv>
      </FlexContainer>
    </FlexDiv>
  );
};
export default CardComponent;

const Heading = styled(Typography)`
  margin-bottom: 25px;
`;
const Subtitle = styled(Typography)`
  margin: 0 auto 25px auto;
  max-width: 915px;
`;
const SvgCard = styled(SVGRing)``;
const CardBody = styled(FlexDiv)`
  display: flex !important;
  background-color: ${({ bgImg }) =>
    bgImg === "blue"
      ? theme.colors.blueCardFallback
      : bgImg === "green"
      ? theme.colors.greenCardFallback
      : theme.colors.cardFallbackBg};
  background-image: ${({ bgImg }) =>
    bgImg === "blue"
      ? theme.colors.blueCardGradient
      : bgImg === "green"
      ? theme.colors.greenCardGradient
      : theme.colors.cardGradient};
  border-radius: 10px;
  padding: 30px;
  position: relative;
  * {
    position: relative;
    z-index: 1;
  }
  > svg {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    max-height: 388px;
    max-width: 244px;
    z-index: 0;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    pointer-events: none;
  }
`;
const BtnDiv = styled(FlexDiv)`
  justify-content: flex-end;
  @media only screen and (max-width: 1099px) {
    justify-content: flex-start;
  }
`;
const CardBanner = styled(FlexDiv)`
  position: absolute;
  bottom: 30px;
  left: -16px;
  p {
    padding: 12px 29px 12px 48px;
    background-color: ${theme.colors.yellow2};
    border-radius: 6px;
  }
  max-width: 286px;
  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 15px 15px 0;
    border-color: transparent ${theme.colors.yellowDark} transparent transparent;
    left: 1px;
    bottom: -13px;
  }
  @media only screen and (max-width: 1099px) {
    bottom: 152px;
    max-width: 266px;
  }
`;
const TopBox = styled(Box)`
  position: relative;
  margin-bottom: 16%;
  flex: 1;
  @media only screen and (max-width: 1099px) {
    margin-bottom: 207px;
  }
`;
const SlideWrap = styled(FlexDiv)`
  .slick-slider {
    width: 100%;
    .slick-dots {
      li {
        &.slick-active {
          button {
            &::before {
              background-color: ${theme.colors.dotsColor};
            }
          }
        }
        button {
          position: relative;
          &::before {
            background-color: rgba(92, 92, 110, 0.2);
            border-radius: 50%;
            height: 8px;
            width: 8px;
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }
    .slick-slide {
      & > div {
        margin: 0 4.5px;
        padding: 15px 17px;
        @media only screen and (max-width: 767px) {
          margin: 0;
          padding: 15px;
        }
        @media only screen and (max-width: 767px) {
          padding: 15px 20px;
        }
      }
    }
  }
`;
